<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
    <base-material-dialog
      :title='item.data === undefined ? "后付款信息" : "后付款信息" '
      :dialog="item.show"
      @on-dialog-change='dialogChange'
      persistent
      max-width='850'
    >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-expansion-panels focusable elevation="1">
                  <v-expansion-panel>
                    <v-expansion-panel-header>合同详情</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <detail-view :item='item.data'></detail-view>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md='4'>
                <v-text-field label="后付费金额(补助金额)" @input="countPrice" hide-details='auto' filled rounded  dense :rules="number" v-model="laterPrice"></v-text-field>
              </v-col>
              <v-col cols="12" md='4'>
                <v-text-field label="合同收费比例" @input="countPrice" hide-details='auto' filled rounded  dense :rules="decimal" v-model="form.chargeRatio"></v-text-field>
              </v-col>
               <v-col cols="12" md='4'>
                <v-text-field label="居间人费用/比例" @input="countPrice" hide-details='auto' filled rounded  dense :rules="number" v-model="form.mediatorPrice"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card outlined class="px-2 mb-5">
                  <div class="my-5">
                    <span class="primary--text size-25">{{form.signPrice}}</span><span class="grey--text">(合同金额)</span>
                    =
                    <span class="primary--text size-25">{{laterPrice}}</span><span class="grey--text">(后付费金额)</span>
                    x
                    <span class="primary--text size-25">{{form.chargeRatio}}</span><span class="grey--text">(合同收费比例)</span>
                  </div>
                  <div :class="form.mediatorPrice < 1 ? 'my-5' : 'my-5 text-decoration-line-through'">
                    <span class="primary--text size-25">{{form.newMediatorPrice}}</span><span class="grey--text">(居间人费)</span>
                    =
                    <span class="primary--text size-25">{{laterPrice}}</span><span class="grey--text">(后付费金额)</span>
                    x
                    <span class="primary--text size-25">{{form.mediatorPrice}}</span><span class="grey--text">(居间人费用比例)</span>
                  </div>
                  <div class="my-5">
                    <span class="red--text">
                      提示:<br>
                      1、当居间人费用比例大于1时居间费用将不再参与计算！<br>
                      2、后付费信息只能修改一次，保存后无法修改，请谨慎操作！<br>
                      </span>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" rounded :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { later } from '@/api/contract/index.js'
  import DetailView from './Detail.vue'

  export default {
    name: 'LaterAdd',
    components: {
      DetailView
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null,
        })
      }
    },
    data() {
      return {
        loading: false,
        number: [
          value => (/^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value)) || `金额必填且为数字`,
        ],
        decimal: [
          value => (/^[0]+(.[0-9]{1,3})?$/.test(value)) || `金额必填且不能大于1`,
        ],
        laterPrice: 0,
        form: {
          id: '',
          signPrice: '',
          chargeRatio: '',
          mediatorPrice: '',
          newMediatorPrice: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          later(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      countPrice () {
        this.form.signPrice = Math.floor(this.laterPrice * this.form.chargeRatio)
        if (this.form.mediatorPrice < 1) {
          this.form.newMediatorPrice = Math.floor(this.laterPrice * this.form.mediatorPrice)
        } else {
          this.form.newMediatorPrice = this.form.mediatorPrice
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form = JSON.parse(JSON.stringify(this.item.data))
            this.countPrice()
          }
        } else {
          this.laterPrice = 0
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data !== null
      }
    }
  }
</script>

<style>
</style>
